import type { ButtonHTMLAttributes } from "react";

type Variant = "primary" | "secondary" | "outline" | "danger" | "ghost";

const variantStyles: Record<Variant, string> = {
  primary:
    "bg-primary text-text-inverse hover:bg-primary-hover",
  secondary:
    "bg-secondary text-text-inverse hover:opacity-90",
  outline:
    "border-2 border-primary text-primary hover:bg-primary hover:text-text-inverse",
  danger:
    "bg-error text-white hover:opacity-90",
  ghost:
    "text-text-secondary hover:bg-surface-sunken",
};

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  loading?: boolean;
}

export default function Button({
  variant = "primary",
  loading,
  disabled,
  className = "",
  children,
  ...props
}: ButtonProps) {
  return (
    <button
      disabled={disabled || loading}
      className={`inline-flex items-center justify-center gap-2 rounded-2xl px-6 py-3 text-base font-semibold transition-colors disabled:opacity-50 disabled:cursor-not-allowed ${variantStyles[variant]} ${className}`}
      {...props}
    >
      {loading && (
        <span className="h-4 w-4 animate-spin rounded-full border-2 border-current border-t-transparent" />
      )}
      {children}
    </button>
  );
}
